export var iconNamesArray = ['Magnify', 'Abs', 'AccountCircleLine', 'AccountCircle', 'AddCircle', 'Add', 'Airbags', 'Amenage', 'AnneeModele', 'Antivol', 'ArrowDown', 'ArrowLeft', 'ArrowRightS', 'ArrowRight', 'ArrowUp', 'ArticlesToilettage', 'Ascenseur', 'AttachmentFill', 'AttachmentLine', 'AutoNeuf', 'AvitoIcon', 'Balcon', 'BankLine', 'BarGraph', 'Bars', 'BaselineDrag', 'BasketballLine', 'Bike', 'BoiteAVitesse', 'Briefcase2Line', 'Building4Line', 'BuildingLine', 'BulleBasse', 'Bump', 'CablageTelephonique', 'Calendar', 'CameraDeRecul', 'Camera', 'Capacite', 'CarLine', 'Car', 'Carburant', 'CardTextOutline', 'Carousserie', 'Cbs', 'CdMp3Bluetooth', 'Chambres', 'ChatBubbleOutline', 'ChatBubble', 'ChatBubblesOutline', 'ChatBubbles', 'Chat', 'Chauffage', 'CheckDoubleLine', 'CheckLine', 'ChevronDown', 'ChevronLeft', 'ChevronRight', 'ChevronUp', 'CircleCheckedOutline', 'CircleChecked', 'CircleUnchecked', 'Climatisation', 'ClockHour', 'CloseCircle', 'CloseOutline', 'CloseWhite', 'Close', 'Concierge', 'Consommation', 'CouchLine', 'CreditCard', 'CuisineEquipee', 'CustomerService', 'Cylindree', 'DateEvent', 'DateRange', 'Delete', 'Delivery2', 'DotsVertical', 'DownloadLine', 'Duplex', 'EBikeLine', 'EBike', 'Edit', 'Electronic', 'Email', 'EqualizerLine', 'EquipementsEnfants', 'ErrorOutline', 'Esp', 'Facebook', 'FerRepasser', 'FileCopyLine', 'FileFind', 'FilterFill', 'Flashlight', 'Floor', 'Floors', 'Gallery', 'Garage', 'Gps', 'Hand', 'Hang', 'HeartBroken', 'HeartOutline', 'Heart', 'Highlight', 'Home3Line', 'HomeSmileOutline', 'HomeSmile', 'Home', 'HotelBedFill', 'Immo', 'Info', 'InformationLine', 'InstagramLine', 'JantesAluminium', 'Jardin', 'Jobs', 'Label', 'Language', 'LayoutGridLine', 'LayoutRowLine', 'LimiteurDeVitesse', 'Linkedin', 'ListCheck2', 'List', 'Loading', 'LocationOn', 'Lock', 'Login', 'LogoutCircleRLine', 'Logout', 'Loti', 'MapMarker', 'MapPinFill', 'MapPinLine', 'MenuDown', 'Messenger', 'Meuble', 'Mezzanine', 'Mileage', 'MinusCircleFill', 'MoreFill', 'NombreDePortes', 'OrdinateurDeBord', 'Origine', 'Parking', 'PhoneCondition', 'PhoneLine', 'PhoneModel', 'PhoneStorage', 'Phone', 'Pieces', 'Piscine', 'PremiereMain', 'PriceTag3Fill', 'PriceTag3Line', 'Price', 'PropertyAge', 'Protected', 'PuissanceFiscale', 'RadarDeRecul', 'Radio2Line', 'Redirect', 'RegulateurDeVitesse', 'Restart', 'Rocket2Line', 'Rocket', 'SacDeReservoir', 'SalleDeBain', 'Search2Line', 'SearchLine', 'Securite', 'SellerType', 'Serviettes', 'Settings2Line', 'Settings3Line', 'Settings', 'ShareLine', 'ShareUpFill', 'Shield', 'SiegesCuir', 'SmartphoneLine', 'SpamLine', 'SpareRoom', 'SquareChecked', 'SquareUnchecked', 'StarFill', 'Star', 'Steering2Line', 'Store2Fill', 'Store2Line', 'Store', 'Subtract', 'SurfaceTotale', 'SwapBoxLine', 'TShirtLine', 'TableSearch', 'Television', 'Terrasse', 'ThumbsUp', 'TimeFill', 'TimeLine', 'Titre', 'ToitOuvrant', 'TrendingUp', 'Twitter', 'Unlock', 'UserOutline', 'UserVoiceLine', 'User', 'VerrouillageCentraliseADistance', 'VisibilityOff', 'Visibility', 'VitresElectriques', 'WashOutline', 'Wash', 'WhatsappLine', 'Wifi', 'Youtube', 'Zoning'];
export var ICONS = {
  Magnify: 'Magnify',
  Abs: 'Abs',
  AccountCircleLine: 'AccountCircleLine',
  AccountCircle: 'AccountCircle',
  AddCircle: 'AddCircle',
  Add: 'Add',
  Airbags: 'Airbags',
  Amenage: 'Amenage',
  AnneeModele: 'AnneeModele',
  Antivol: 'Antivol',
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRightS: 'ArrowRightS',
  ArrowRight: 'ArrowRight',
  ArrowUp: 'ArrowUp',
  ArticlesToilettage: 'ArticlesToilettage',
  Ascenseur: 'Ascenseur',
  AttachmentFill: 'AttachmentFill',
  AttachmentLine: 'AttachmentLine',
  AutoNeuf: 'AutoNeuf',
  AvitoIcon: 'AvitoIcon',
  Balcon: 'Balcon',
  BankLine: 'BankLine',
  BarGraph: 'BarGraph',
  Bars: 'Bars',
  BaselineDrag: 'BaselineDrag',
  BasketballLine: 'BasketballLine',
  Bike: 'Bike',
  BoiteAVitesse: 'BoiteAVitesse',
  Briefcase2Line: 'Briefcase2Line',
  Building4Line: 'Building4Line',
  BuildingLine: 'BuildingLine',
  BulleBasse: 'BulleBasse',
  Bump: 'Bump',
  CablageTelephonique: 'CablageTelephonique',
  Calendar: 'Calendar',
  CameraDeRecul: 'CameraDeRecul',
  Camera: 'Camera',
  Capacite: 'Capacite',
  CarLine: 'CarLine',
  Car: 'Car',
  Carburant: 'Carburant',
  CardTextOutline: 'CardTextOutline',
  Carousserie: 'Carousserie',
  Cbs: 'Cbs',
  CdMp3Bluetooth: 'CdMp3Bluetooth',
  Chambres: 'Chambres',
  ChatBubbleOutline: 'ChatBubbleOutline',
  ChatBubble: 'ChatBubble',
  ChatBubblesOutline: 'ChatBubblesOutline',
  ChatBubbles: 'ChatBubbles',
  Chat: 'Chat',
  Chauffage: 'Chauffage',
  CheckDoubleLine: 'CheckDoubleLine',
  CheckLine: 'CheckLine',
  ChevronDown: 'ChevronDown',
  ChevronLeft: 'ChevronLeft',
  ChevronRight: 'ChevronRight',
  ChevronUp: 'ChevronUp',
  CircleCheckedOutline: 'CircleCheckedOutline',
  CircleChecked: 'CircleChecked',
  CircleUnchecked: 'CircleUnchecked',
  Climatisation: 'Climatisation',
  ClockHour: 'ClockHour',
  CloseCircle: 'CloseCircle',
  CloseOutline: 'CloseOutline',
  CloseWhite: 'CloseWhite',
  Close: 'Close',
  Concierge: 'Concierge',
  Consommation: 'Consommation',
  CouchLine: 'CouchLine',
  CreditCard: 'CreditCard',
  CuisineEquipee: 'CuisineEquipee',
  CustomerService: 'CustomerService',
  Cylindree: 'Cylindree',
  DateEvent: 'DateEvent',
  DateRange: 'DateRange',
  Delete: 'Delete',
  Delivery2: 'Delivery2',
  DotsVertical: 'DotsVertical',
  DownloadLine: 'DownloadLine',
  Duplex: 'Duplex',
  EBikeLine: 'EBikeLine',
  EBike: 'EBike',
  Edit: 'Edit',
  Electronic: 'Electronic',
  Email: 'Email',
  EqualizerLine: 'EqualizerLine',
  EquipementsEnfants: 'EquipementsEnfants',
  ErrorOutline: 'ErrorOutline',
  Esp: 'Esp',
  Facebook: 'Facebook',
  FerRepasser: 'FerRepasser',
  FileCopyLine: 'FileCopyLine',
  FileFind: 'FileFind',
  FilterFill: 'FilterFill',
  Flashlight: 'Flashlight',
  Floor: 'Floor',
  Floors: 'Floors',
  Gallery: 'Gallery',
  Garage: 'Garage',
  Gps: 'Gps',
  Hand: 'Hand',
  Hang: 'Hang',
  HeartBroken: 'HeartBroken',
  HeartOutline: 'HeartOutline',
  Heart: 'Heart',
  Highlight: 'Highlight',
  Home3Line: 'Home3Line',
  HomeSmileOutline: 'HomeSmileOutline',
  HomeSmile: 'HomeSmile',
  Home: 'Home',
  HotelBedFill: 'HotelBedFill',
  Immo: 'Immo',
  Info: 'Info',
  InformationLine: 'InformationLine',
  InstagramLine: 'InstagramLine',
  JantesAluminium: 'JantesAluminium',
  Jardin: 'Jardin',
  Jobs: 'Jobs',
  Label: 'Label',
  Language: 'Language',
  LayoutGridLine: 'LayoutGridLine',
  LayoutRowLine: 'LayoutRowLine',
  LimiteurDeVitesse: 'LimiteurDeVitesse',
  Linkedin: 'Linkedin',
  ListCheck2: 'ListCheck2',
  List: 'List',
  Loading: 'Loading',
  LocationOn: 'LocationOn',
  Lock: 'Lock',
  Login: 'Login',
  LogoutCircleRLine: 'LogoutCircleRLine',
  Logout: 'Logout',
  Loti: 'Loti',
  MapMarker: 'MapMarker',
  MapPinFill: 'MapPinFill',
  MapPinLine: 'MapPinLine',
  MenuDown: 'MenuDown',
  Messenger: 'Messenger',
  Meuble: 'Meuble',
  Mezzanine: 'Mezzanine',
  Mileage: 'Mileage',
  MinusCircleFill: 'MinusCircleFill',
  MoreFill: 'MoreFill',
  NombreDePortes: 'NombreDePortes',
  OrdinateurDeBord: 'OrdinateurDeBord',
  Origine: 'Origine',
  Parking: 'Parking',
  PhoneCondition: 'PhoneCondition',
  PhoneLine: 'PhoneLine',
  PhoneModel: 'PhoneModel',
  PhoneStorage: 'PhoneStorage',
  Phone: 'Phone',
  Pieces: 'Pieces',
  Piscine: 'Piscine',
  PremiereMain: 'PremiereMain',
  PriceTag3Fill: 'PriceTag3Fill',
  PriceTag3Line: 'PriceTag3Line',
  Price: 'Price',
  PropertyAge: 'PropertyAge',
  Protected: 'Protected',
  PuissanceFiscale: 'PuissanceFiscale',
  RadarDeRecul: 'RadarDeRecul',
  Radio2Line: 'Radio2Line',
  Redirect: 'Redirect',
  RegulateurDeVitesse: 'RegulateurDeVitesse',
  Restart: 'Restart',
  Rocket2Line: 'Rocket2Line',
  Rocket: 'Rocket',
  SacDeReservoir: 'SacDeReservoir',
  SalleDeBain: 'SalleDeBain',
  Search2Line: 'Search2Line',
  SearchLine: 'SearchLine',
  Securite: 'Securite',
  SellerType: 'SellerType',
  Serviettes: 'Serviettes',
  Settings2Line: 'Settings2Line',
  Settings3Line: 'Settings3Line',
  Settings: 'Settings',
  ShareLine: 'ShareLine',
  ShareUpFill: 'ShareUpFill',
  Shield: 'Shield',
  SiegesCuir: 'SiegesCuir',
  SmartphoneLine: 'SmartphoneLine',
  SpamLine: 'SpamLine',
  SpareRoom: 'SpareRoom',
  SquareChecked: 'SquareChecked',
  SquareUnchecked: 'SquareUnchecked',
  StarFill: 'StarFill',
  Star: 'Star',
  Steering2Line: 'Steering2Line',
  Store2Fill: 'Store2Fill',
  Store2Line: 'Store2Line',
  Store: 'Store',
  Subtract: 'Subtract',
  SurfaceTotale: 'SurfaceTotale',
  SwapBoxLine: 'SwapBoxLine',
  TShirtLine: 'TShirtLine',
  TableSearch: 'TableSearch',
  Television: 'Television',
  Terrasse: 'Terrasse',
  ThumbsUp: 'ThumbsUp',
  TimeFill: 'TimeFill',
  TimeLine: 'TimeLine',
  Titre: 'Titre',
  ToitOuvrant: 'ToitOuvrant',
  TrendingUp: 'TrendingUp',
  Twitter: 'Twitter',
  Unlock: 'Unlock',
  UserOutline: 'UserOutline',
  UserVoiceLine: 'UserVoiceLine',
  User: 'User',
  VerrouillageCentraliseADistance: 'VerrouillageCentraliseADistance',
  VisibilityOff: 'VisibilityOff',
  Visibility: 'Visibility',
  VitresElectriques: 'VitresElectriques',
  WashOutline: 'WashOutline',
  Wash: 'Wash',
  WhatsappLine: 'WhatsappLine',
  Wifi: 'Wifi',
  Youtube: 'Youtube',
  Zoning: 'Zoning'
};